import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6 visible lg:hidden" }
const _hoisted_2 = { class: "w-full border border-gray-100 p-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "p-2" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b text-left space-x-3 bg-primary-light p-3 text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-sm font-medium p-2" }),
    /*#__PURE__*/_createElementVNode("th", { class: "text-sm font-medium p-2" }, "Candidates"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-sm font-medium p-2" }, "Rejected"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-sm font-medium p-2" }, "Drop off")
  ])
], -1)
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "p-1 text-primary" }
const _hoisted_6 = { class: "text-center p-1" }
const _hoisted_7 = { class: "text-center p-1" }
const _hoisted_8 = { class: "text-center p-1" }
const _hoisted_9 = { class: "flex flex-row justify-around p-2 items-center text-center opacity-50 mt-4" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "block mx-auto my-auto bg-gray-200 text-center p-2 rounded" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm mt-2" }, "Total canddidates", -1)
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "block mx-auto my-auto bg-red-200 text-center p-2 rounded" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm mt-2" }, "Rejected", -1)
const _hoisted_16 = { class: "lg:flex flex-row w-full justify-between hidden lg:visible lg:mb-4" }
const _hoisted_17 = {
  key: 0,
  class: "items-center flex flex-col opacity-40 space-y-1 w-full"
}
const _hoisted_18 = { class: "block mx-auto my-auto bg-gray-200 text-center p-2 rounded text-lg" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-center text-sm flex justify-start items-center 2xl:text-xs sm:text-xxs" }, "Total candidates ", -1)
const _hoisted_20 = { class: "items-center flex flex-col opacity-40 w-full" }
const _hoisted_21 = { class: "text-center text-sm flex justify-start items-center 2xl:text-xs sm:text-xxs" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-col text-center mt-4"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-pink-600 text-xs font-bold" }, "Rejected", -1)
const _hoisted_24 = {
  key: 1,
  class: "flex flex-col text-center mt-4"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-pink-600 text-xs font-bold" }, "Drop off", -1)
const _hoisted_26 = {
  key: 1,
  class: "py-4 px-7 flex justify-center"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-300",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 2,
  class: "py-4 px-7 flex justify-start text-gray-300 text-xl font-semibold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("tbody", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stages && _ctx.stages.length > 0 && _ctx.stages, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: i,
              class: _normalizeClass(i % 2 == 0 ? 'bg-gray-100' : '')
            }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(item.stage.name), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(item.number_candidates), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(item.rejected_count), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(item.drop_off_count), 1)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.totalCandidates), 1),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.rejected), 1),
          _hoisted_15
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stages && _ctx.stages.length > 0 && _ctx.stages, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["flex flex-row justify-between items-center w-full", 
				i !== _ctx.stages.length - 1 ? 'justify-between ' : 'justify-start'
			])
        }, [
          (i === _ctx.stages.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.totalCandidates), 1),
                _hoisted_19
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", {
              class: _normalizeClass(["block mx-auto my-auto bg-gray-200 text-center p-2 rounded", [
						i === _ctx.stages.length - 1
							? 'text-lg font-medium  bg-pink-200 text-pink-700'
							: ' bg-gray-200',
					]])
            }, _toDisplayString(item.number_candidates), 3),
            _createElementVNode("span", _hoisted_21, _toDisplayString(item.stage.name), 1),
            (i !== _ctx.stages.length - 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("span", null, _toDisplayString(item.rejected_count), 1),
                  _hoisted_23
                ]))
              : _createCommentVNode("", true),
            (i !== _ctx.stages.length - 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString(item.drop_off_count), 1),
                  _hoisted_25
                ]))
              : _createCommentVNode("", true)
          ]),
          (i !== _ctx.stages.length - 1 && i !== _ctx.stages.length - 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
            : (i === _ctx.stages.length - 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, " | "))
              : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ])
  ], 64))
}